"use client"

import { useCustomSearchParams } from "@/hooks/use-search-params"
import { usePathname } from "next/navigation"
import { ReactNode } from "react"
import { SWRConfig } from "swr"
import { prettifyError, z } from "zod"

/* -------------------------------------------------------------------------------------------------
 * component
 * -----------------------------------------------------------------------------------------------*/

const SwrGlobalConfig = ({ children }: { children: ReactNode }) => {
  const pathname = usePathname()
  const [, setSearchParams] = useCustomSearchParams()

  return (
    <SWRConfig
      value={{
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        onError: (error) => {
          if (error instanceof z.ZodError) {
            const validationError = prettifyError(error)
            console.error("SWR-ERROR", error, validationError.toString())
          } else {
            console.error("SWR-ERROR", error)
          }

          if (pathname === "/") {
            setSearchParams((prevParams) => {
              prevParams.set("errorBanner", "serviceError")
              return prevParams
            })
          } else {
            throw error
          }
        },
      }}
    >
      {children}
    </SWRConfig>
  )
}

export { SwrGlobalConfig }
